import React from 'react';
import R from 'ramda';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { firebase } from '../../common/lib/redux-firebase';
import { Link } from 'react-router';
import { Loading, Header, FilledButton, Footer } from '../app/components';
import { onPropertiesPresence } from '../../common/properties/actions';
import Properties from './Properties';
import PropertiesSearch from '../propertiesSearch/PropertiesSearch';

class PropertiesPage extends React.Component {
  render() {
    const { location, viewer, properties, hasSearched } = this.props;

    if (properties === undefined) {
      return <Loading loading loadingColor="#00E39A" backgroundColor="#ffffff" />;
    }

    if (properties === null) {
      return (
        <div>
          <div className="properties-page not-found">
            <Helmet title="Húsfinnur" />
            <Header title="Allar eignir" from="/" />
            <h2>Það eru engar eignir í kerfinu :(</h2>
            {viewer &&
              <div className="button-wrapper">
                <Link
                  to={{
                    pathname: '/createProperty',
                    state: { from: '/' },
                  }}
                >
                  <FilledButton
                    className="big"
                    content={
                      <div>
                        <span className="icon-new-property-icon" />
                        <p>Skráðu þína eign hér!</p>
                      </div>
                    }
                    color="#222222"
                    backgroundColor="#00e39a"
                  />
                </Link>
              </div>
            }
          </div>
          <Footer />
        </div>
      );
    }

    return (
      <div className="properties-page" ref={node => (this.node = node)}>
        <Helmet title="Húsfinnur" />
        <Header title={hasSearched ? 'Leitarniðurstöður' : 'Allar eignir'} from="/" />
        <h2>{hasSearched ? 'Leitarniðurstöður' : 'Allar eignir'}</h2>
        <PropertiesSearch
          location={location}
          propertiesPageNode={this.node}
          hasSearched={hasSearched}
        />
        {(hasSearched && R.isEmpty(properties)) ?
          <div className="properties">
            <p className="no-search-results">Engar eignir fundust :(</p>
          </div>
        :
          <Properties properties={properties} />
        }
        {viewer &&
          <div className="button-wrapper">
            <Link
              to={{
                pathname: '/createProperty',
                state: { from: '/' },
              }}
            >
              <FilledButton
                className="big"
                content={
                  <div>
                    <span className="icon-new-property-icon" />
                    <p>Skráðu þína eign hér!</p>
                  </div>
                }
                color="#222222"
                backgroundColor="#00e39a"
              />
            </Link>
          </div>
        }
        <Footer />
      </div>
    );
  }
}

PropertiesPage.propTypes = {
  location: React.PropTypes.any,
  viewer: React.PropTypes.object,
  properties: React.PropTypes.array,
  hasSearched: React.PropTypes.bool,
};

export default R.compose(
  connect(
    state => ({
      viewer: state.users.viewer,
      properties: state.properties.properties,
      hasSearched: state.properties.hasSearched,
    }),
    { onPropertiesPresence },
  ),
  firebase((database, props) => {
    const propertiesPresenceRef = database.child('properties').orderByChild('active').equalTo(true);
    return [
      [propertiesPresenceRef, 'on', 'value', props.onPropertiesPresence],
    ];
  }),
)(PropertiesPage);



// WEBPACK FOOTER //
// ./src/browser/properties/PropertiesPage.js